import React, { memo } from 'react'

import PropTypes from 'prop-types'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

import { Grid, Hidden, Typography, makeStyles } from '@material-ui/core'
import MUIPagination from '@material-ui/lab/Pagination'

import InputGroup from '../Forms/InputGroup/InputGroup'

const perPageOptions = [5, 10, 15, 25, 50, 100, 200]
const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    marginTop: spacing(1)
  }
}))

const Pagination = ({ pagination, pageChanged, perPageChanged, translate }) => {
  const { total = 0, perPage = 10, currentPage = 0, lastPage = 0, from = 0, to = 0 } = pagination
  const classes = useStyles()
  const pageOptions = Array.from(Array(lastPage), (value, index) => ({
    key: index + 1,
    value: index + 1,
    label: `${index + 1}`
  }))

  return (
    <Grid
      container
      spacing={1}
      alignItems={'flex-start'}
      justify={'space-between'}
      className={classes.root}>
      <Hidden xsDown>
        <Grid item xs>
          <MUIPagination
            count={lastPage}
            shape={'rounded'}
            showFirstButton
            showLastButton
            siblingCount={0}
            // boundaryCount={1}
            page={currentPage}
            onChange={pageChanged}
          />
        </Grid>
      </Hidden>
      <Hidden smUp>
        <Grid container item xs>
          <InputGroup
            label={translate('pagiPage')}
            inputType={'originalSelect'}
            changed={e => pageChanged(e, +e.target.value)}
            configs={{
              options: pageOptions
            }}
            variant={'outlined'}
            inputValue={currentPage}
            noMargin
          />
        </Grid>
      </Hidden>
      <Grid container item xs={5} lg={6} justify={'flex-end'} alignItems={'flex-end'} spacing={1}>
        <Hidden smDown>
          <Grid item xs>
            <Typography align={'right'} variant={'body2'}>
              {`${translate('showing')} ${from || 0} - ${to || 0} ${translate(
                'records'
              )} ${translate('of')} ${total || 0} ${translate('records')}`}
            </Typography>
          </Grid>
        </Hidden>
        <Grid item xs sm={8} md={4}>
          <InputGroup
            inputType={'newselect'}
            label={translate('pagiPerPage')}
            changed={e => perPageChanged(+e)}
            configs={{
              options: perPageOptions,
              clearDisabled: true,
              getOptionLabel: item => `${item}`,
              size: 'small',
              freeSolo: true
            }}
            variant={'outlined'}
            inputValue={perPage}
            noMargin
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

Pagination.propTypes = {
  pagination: PropTypes.shape({
    pagination: PropTypes.shape({
      total: PropTypes.number.isRequired,
      perPage: PropTypes.number.isRequired,
      currentPage: PropTypes.number.isRequired,
      lastPage: PropTypes.number.isRequired,
      from: PropTypes.number.isRequired,
      to: PropTypes.number.isRequired
    })
  }).isRequired
}

Pagination.defaultProps = {
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 0,
    lastPage: 0,
    from: 0,
    to: 0
  }
}

export default withTranslate(memo(Pagination))
